

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface MedicineInTakeParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface MedicineInTake {
    id?: any;
    medicineId:any;
    takenDateTime:any;
    dose_Freq:string;
    nurseId:any;
    admissionId:any
    regId:any;
    visitId:any;
    tenantId: any;
    branchId: any;
    
    parameters?: MedicineInTakeParameter[];
    links?: any;
}


export abstract class MedicineInTakeData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<MedicineInTake[]>;
    abstract create(url: string, data: MedicineInTake): Observable<MedicineInTake[]>;
    abstract update(url: string, data: MedicineInTake): Observable<MedicineInTake>;
    abstract delete(url: string): Observable<any>;
}
